import type { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/react';

import { Close } from '@zoomit/icons';
import { Image } from '@zoomit/primitives';
import { Box } from '@zoomit/primitives';
import { BaseMediaUrl } from '@zoomit/web-kit';
import { cssVar, theme } from '@zoomit/zoomit-ds';

export const StickerNodeView = (props: NodeViewProps) => {
  const { stickerId } = props.node.attrs;
  return (
    <NodeViewWrapper className="relative">
      <span className={'relative ml-3 inline-block h-16 w-16'} data-drag-handle>
        <Image
          className={'rounded-sm object-cover'}
          width={64}
          height={64}
          src={`${BaseMediaUrl}/${stickerId}`}
          alt={`sticker-${stickerId}`}
        />
      </span>
      <Box
        className={
          'bg-grey3 absolute top-0 left-0 grid h-4 w-4 cursor-pointer place-content-center rounded-full'
        }
        onClick={props.deleteNode}
      >
        <Close size="sm" fill={cssVar(theme.white)} />
      </Box>
    </NodeViewWrapper>
  );
};
